import { CuriosityTranslation } from '@procureai/curiosity-ui-mui';

export interface SupplierContactEntity {
  sourceReference?: string;
  firstName: string;
  lastName: string;
  preferredLanguage: string;
  email: string;
  roles: string[];
}
export interface SupplierLocationEntity {
  sourceReference?: string;
  address: string;
  city: string;
  postalCode: string;
  countryCode: string;
}

export enum SupplierContactHitId {
  NEW = 'NEW',
}

export type SupplierContactAutocompleteHit = CuriosityTranslation<SupplierContactEntity>;
export type SupplierLocationAutocompleteHit = CuriosityTranslation<SupplierLocationEntity>;
